import(/* webpackMode: "eager", webpackExports: ["Wizard"] */ "/app/apps/copilot/components/sections/wizard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebchatButton"] */ "/app/apps/copilot/components/webchat-button.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.28_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@22.15.30_react-dom_9ac67e52a22231b328284a105085c37e/node_modules/next/dist/client/script.js");
